import { activityFetch as fetch } from '../../components/feedback/requestActivity'
import { titleTheme, pageTheme, headerTheme, contentTheme, subTheme, cardTheme } from '../../components/consoleTheme'
import NodeSetupGuide from '../../components/NodeSetupGuide'

import { useState, useEffect } from "react"
import { useLocation, useSearchParams } from 'react-router-dom'
import styled from "styled-components"
import { nodeConsoleTarget } from "./nodeConsoleTarget"
import {
  Plus, RefreshCw, Trash2, Play, Server, FileCode, Boxes, Network,
  Edit3, Save, X, Download, KeyRound, Terminal, ChevronRight,
} from "lucide-react"

const API = "/api/orch"
function getToken() { return sessionStorage.getItem("token") || localStorage.getItem("token") }
function authHeaders(json = true) {
  const h = {}
  if (json) h["Content-Type"] = "application/json"
  const t = getToken()
  if (t) h["Authorization"] = `Bearer ${t}`
  return h
}
const DEFAULT_PB = `- name: 연결 확인 (ping)
  hosts: all
  gather_facts: no
  tasks:
    - name: ping
      ansible.builtin.ping:
`

const PageContainer = styled.div`
  ${pageTheme}
padding:0; background:#f8fafc; min-height:100vh;`
const Header = styled.header`
  ${headerTheme}

  display:flex; align-items:center; justify-content:space-between;
  padding:1rem 2rem; background:#fff; border-bottom:1px solid #e2e8f0;
  @media(max-width:768px){padding:1rem;flex-wrap:wrap;gap:.75rem;align-items:flex-start;}`
const Title = styled.h1`
 ${titleTheme}
font-size:1.25rem; font-weight:600; color:#1e293b;`
const Sub = styled.p`
  ${subTheme}
margin:.25rem 0 0; font-size:.8rem; color:#94a3b8;`
const Button = styled.button`
  display:inline-flex; align-items:center; gap:.5rem; padding:.5rem 1rem;
  border-radius:.375rem; font-weight:500; cursor:pointer;
  ${(p) => p.primary
    ? `background:var(--accent);color:#fff;border:none;&:hover{background:#115855;}`
    : `background:#fff;color:#64748b;border:1px solid #e2e8f0;&:hover{background:#f8fafc;}`}
  &:disabled{opacity:.5;cursor:default;}`
const Content = styled.div`
  ${contentTheme}
padding:2rem;@media(max-width:768px){padding:1rem;}`
const Card = styled.div`
  ${cardTheme}
background:#fff; border:1px solid #e2e8f0; border-radius:.5rem; overflow:hidden; margin-bottom:1.5rem;`
const CardHead = styled.div`
  padding:.85rem 1.5rem; border-bottom:1px solid #f1f5f9; font-weight:600; color:#334155;
  display:flex; align-items:center; justify-content:space-between; gap:.5rem;
  > span{display:flex;align-items:center;gap:.5rem;}
  @media(max-width:768px){padding:1rem;flex-wrap:wrap;>span{min-width:0;overflow-wrap:anywhere;}}`
const Empty = styled.div`padding:1.6rem; text-align:center; color:#94a3b8; font-size:.88rem;`
const Mono = styled.code`font-family:ui-monospace,Menlo,Consolas,monospace; font-size:.8rem; color:#334155;`
const TabBar = styled.div`overflow-y:hidden;display:flex; gap:.25rem; border-bottom:1px solid #e2e8f0; margin-bottom:1.5rem;overflow-x:auto;max-width:100%;-webkit-overflow-scrolling:touch;`
const TabBtn = styled.button`
  display:inline-flex; align-items:center; gap:.4rem; padding:.6rem 1rem; background:none; border:none; cursor:pointer;
  font-size:.9rem; font-weight:${(p) => (p.active ? 600 : 500)}; color:${(p) => (p.active ? "var(--accent)" : "#64748b")};
  border-bottom:2px solid ${(p) => (p.active ? "var(--accent)" : "transparent")}; margin-bottom:-1px; &:hover{color:var(--accent);}`
const Row = styled.div`
  display:grid; grid-template-columns:${(p) => p.cols || "auto"}; gap:.5rem; align-items:center;
  padding:.7rem 1.5rem; border-bottom:1px solid #f1f5f9; font-size:.86rem; &:last-child{border-bottom:none;}
  @media(max-width:768px){grid-template-columns:minmax(0,1fr) minmax(0,1fr);padding:1rem;gap:.65rem;border-bottom:8px solid #f8fafc;>*{min-width:0;overflow-wrap:anywhere;}>:first-child,>:last-child{grid-column:1/-1;}}`
const IconBtn = styled.button`
  background:none; border:1px solid #e2e8f0; border-radius:6px; padding:4px 8px; cursor:pointer; color:#64748b;
  display:inline-flex; align-items:center; gap:4px; font-size:.78rem; &:hover{color:var(--accent);border-color:var(--accent);}`
const Input = styled.input`padding:.5rem .7rem; border:1px solid #e2e8f0; border-radius:6px; outline:none; font-size:.85rem; &:focus{border-color:var(--accent);}`
const Select = styled.select`padding:.5rem .7rem; border:1px solid #e2e8f0; border-radius:6px; outline:none; font-size:.85rem; background:#fff;`
const Form = styled.div`display:flex; flex-wrap:wrap; gap:.5rem; padding:1rem 1.5rem; border-bottom:1px solid #f1f5f9; align-items:center;@media(max-width:768px){padding:1rem;flex-direction:column;align-items:stretch;>*{width:100%;}}`
const TextArea = styled.textarea`
  width:100%; min-height:240px; padding:.8rem; border:1px solid #e2e8f0; border-radius:6px; outline:none;
  font-family:ui-monospace,Menlo,Consolas,monospace; font-size:.82rem; line-height:1.5; resize:vertical;
  &:focus{border-color:var(--accent);}`
const Pre = styled.pre`
  background:#0f172a; color:#e2e8f0; border-radius:8px; padding:1rem; margin:0; overflow:auto; max-height:420px;
  font-family:ui-monospace,Menlo,Consolas,monospace; font-size:.78rem; line-height:1.5; white-space:pre-wrap; word-break:break-word;`
const Badge = styled.span`
  display:inline-block; padding:1px 8px; border-radius:999px; font-size:.72rem; font-weight:600;
  ${(p) => p.s === "success" ? "background:#dcfce7;color:#166534;"
    : p.s === "failed" ? "background:#fee2e2;color:#991b1b;"
    : p.s === "running" ? "background:#dbeafe;color:#1e40af;" : "background:#f1f5f9;color:#475569;"}`
const Note = styled.div`
  display:flex; gap:.6rem; padding:.85rem 1rem; border-radius:8px; font-size:.84rem; line-height:1.55;
  background:#eff6ff; border:1px solid #bfdbfe; color:#1e40af; margin:0 1.5rem 1rem;`

/* ───────────────────────── Ansible ───────────────────────── */
function AnsiblePanel() {
  const [hosts, setHosts] = useState([])
  const [playbooks, setPlaybooks] = useState([])
  const [runs, setRuns] = useState([])
  const [sel, setSel] = useState(new Set())
  const [pbId, setPbId] = useState("")
  const [busy, setBusy] = useState("")
  const [output, setOutput] = useState(null)
  const [addingHost, setAddingHost] = useState(false)
  const [hostForm, setHostForm] = useState({ name: "", address: "", ssh_user: "root", ssh_port: "22", secret_type: "key", ssh_secret: "" })
  const [editor, setEditor] = useState(null) // {pb_id?, name, content}

  const load = async () => {
    try {
      const [h, p, r] = await Promise.all([
        fetch(`${API}/hosts`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()),
        fetch(`${API}/playbooks`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()),
        fetch(`${API}/runs`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()),
      ])
      setHosts(h.hosts || []); setPlaybooks(p.playbooks || []); setRuns(r.runs || [])
      if (!pbId && p.playbooks?.[0]) setPbId(String(p.playbooks[0].pb_id))
    } catch (e) {}
  }
  useEffect(() => { load() }, [])

  const toggle = (id) => setSel((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n })

  const addHost = async () => {
    if (!hostForm.name || !hostForm.address) { alert("이름·주소는 필수입니다."); return }
    setBusy("addhost")
    try {
      const res = await fetch(`${API}/hosts`, { method: "POST", headers: authHeaders(), credentials: "include", body: JSON.stringify(hostForm) })
      if (!res.ok) { alert("등록 실패"); return }
      setHostForm({ name: "", address: "", ssh_user: "root", ssh_port: "22", secret_type: "key", ssh_secret: "" })
      setAddingHost(false); load()
    } finally { setBusy("") }
  }
  const importVpc = async () => {
    setBusy("import")
    try {
      const res = await fetch(`${API}/hosts/import-vpc`, { method: "POST", headers: authHeaders(false), credentials: "include" })
      const d = await res.json().catch(() => ({}))
      if (res.ok) alert(`${d.added || 0}개 가져옴 (VPC 피어 ${d.total || 0}개). SSH 키/비번은 각 호스트 편집에서 설정하세요.`)
      load()
    } finally { setBusy("") }
  }
  const setCred = async (host) => {
    const secret = window.prompt(`${host.name} 의 SSH ${host.secret_type === "password" ? "비밀번호" : "개인키(전체 붙여넣기)"} 입력:`)
    if (secret == null) return
    await fetch(`${API}/hosts/${host.host_id}`, { method: "PUT", headers: authHeaders(), credentials: "include", body: JSON.stringify({ ssh_secret: secret }) })
    load()
  }
  const delHost = async (id) => {
    if (!window.confirm("호스트를 삭제할까요?")) return
    await fetch(`${API}/hosts/${id}`, { method: "DELETE", headers: authHeaders(false), credentials: "include" }); load()
  }

  const savePb = async () => {
    if (!editor.name) { alert("플레이북 이름이 필요합니다."); return }
    setBusy("savepb")
    try {
      if (editor.pb_id) {
        await fetch(`${API}/playbooks/${editor.pb_id}`, { method: "PUT", headers: authHeaders(), credentials: "include", body: JSON.stringify({ name: editor.name, content: editor.content }) })
      } else {
        await fetch(`${API}/playbooks`, { method: "POST", headers: authHeaders(), credentials: "include", body: JSON.stringify({ name: editor.name, content: editor.content }) })
      }
      setEditor(null); load()
    } finally { setBusy("") }
  }
  const delPb = async (id) => {
    if (!window.confirm("플레이북을 삭제할까요?")) return
    await fetch(`${API}/playbooks/${id}`, { method: "DELETE", headers: authHeaders(false), credentials: "include" }); load()
  }

  const run = async () => {
    if (!pbId || sel.size === 0) { alert("플레이북과 대상 호스트를 선택하세요."); return }
    setBusy("run"); setOutput({ status: "running", output: "실행 중…" })
    try {
      const res = await fetch(`${API}/run`, {
        method: "POST", headers: authHeaders(), credentials: "include",
        body: JSON.stringify({ pb_id: Number(pbId), host_ids: [...sel] }),
      })
      const d = await res.json().catch(() => ({}))
      if (!res.ok) { setOutput({ status: "failed", output: d.error || "실행 실패" }); return }
      setOutput(d); load()
    } catch (e) { setOutput({ status: "failed", output: e.message }) }
    finally { setBusy("") }
  }

  if (editor) {
    return (
      <Card>
        <CardHead>
          <span><FileCode size={16} /> {editor.pb_id ? "플레이북 편집" : "새 플레이북"}</span>
          <span>
            <IconBtn onClick={() => setEditor(null)}><X size={13} /> 취소</IconBtn>
            <Button primary onClick={savePb} disabled={busy === "savepb"} style={{ marginLeft: 6 }}><Save size={15} /> 저장</Button>
          </span>
        </CardHead>
        <div style={{ padding: "1rem 1.5rem" }}>
          <Input placeholder="플레이북 이름" value={editor.name} onChange={(e) => setEditor({ ...editor, name: e.target.value })} style={{ width: 320, marginBottom: ".7rem" }} />
          <TextArea value={editor.content} onChange={(e) => setEditor({ ...editor, content: e.target.value })} spellCheck={false} />
          <p style={{ color: "#94a3b8", fontSize: ".78rem", marginTop: ".5rem" }}>YAML 플레이북. <Mono>hosts: all</Mono> 로 선택한 호스트 전체를 대상으로 합니다.</p>
        </div>
      </Card>
    )
  }

  return (
    <>
      <Note>
        <Terminal size={18} style={{ flexShrink: 0 }} />
        <span>대상 호스트를 인벤토리에 등록(또는 VPC 피어 가져오기)하고 SSH 키/비번을 설정한 뒤, 플레이북을 선택해 실행합니다.
          대상은 <strong>SSH 접속 가능한 Linux 호스트</strong>입니다.</span>
      </Note>

      {/* 인벤토리 */}
      <Card>
        <CardHead>
          <span><Server size={16} /> 인벤토리 (호스트 {hosts.length})</span>
          <span style={{ display: "flex", gap: 6 }}>
            <IconBtn onClick={importVpc} disabled={busy === "import"}><Download size={13} /> VPC 피어 가져오기</IconBtn>
            <IconBtn onClick={() => setAddingHost((v) => !v)}><Plus size={13} /> 호스트 추가</IconBtn>
          </span>
        </CardHead>
        {addingHost && (
          <Form>
            <Input placeholder="이름" value={hostForm.name} onChange={(e) => setHostForm({ ...hostForm, name: e.target.value })} />
            <Input placeholder="주소(IP/도메인)" value={hostForm.address} onChange={(e) => setHostForm({ ...hostForm, address: e.target.value })} />
            <Input placeholder="SSH 계정" value={hostForm.ssh_user} onChange={(e) => setHostForm({ ...hostForm, ssh_user: e.target.value })} style={{ width: 110 }} />
            <Input placeholder="포트" value={hostForm.ssh_port} onChange={(e) => setHostForm({ ...hostForm, ssh_port: e.target.value })} style={{ width: 70 }} />
            <Select value={hostForm.secret_type} onChange={(e) => setHostForm({ ...hostForm, secret_type: e.target.value })}>
              <option value="key">개인키</option><option value="password">비밀번호</option>
            </Select>
            <Input placeholder={hostForm.secret_type === "password" ? "비밀번호" : "개인키(선택, 나중에 가능)"} type={hostForm.secret_type === "password" ? "password" : "text"}
              value={hostForm.ssh_secret} onChange={(e) => setHostForm({ ...hostForm, ssh_secret: e.target.value })} style={{ flex: 1, minWidth: 160 }} />
            <Button primary onClick={addHost} disabled={busy === "addhost"}>추가</Button>
          </Form>
        )}
        {hosts.length === 0 ? <Empty>등록된 호스트가 없습니다.</Empty> : hosts.map((h) => (
          <Row key={h.host_id} cols="24px 1.4fr 1.6fr 1fr .9fr auto">
            <input type="checkbox" checked={sel.has(h.host_id)} onChange={() => toggle(h.host_id)} />
            <span style={{ fontWeight: 600, color: "#1e293b" }}>{h.name}</span>
            <Mono>{h.ssh_user}@{h.address}:{h.ssh_port}</Mono>
            <span style={{ color: "#64748b" }}>{h.secret_type === "password" ? "비밀번호" : "개인키"}</span>
            <span style={{ color: h.has_secret ? "#16a34a" : "#ef4444", fontSize: ".8rem" }}>{h.has_secret ? "자격 설정됨" : "자격 없음"}</span>
            <span style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
              <IconBtn onClick={() => setCred(h)} title="SSH 자격 설정"><KeyRound size={13} /></IconBtn>
              <IconBtn style={{ borderColor: "#fecaca", color: "#ef4444" }} onClick={() => delHost(h.host_id)}><Trash2 size={13} /></IconBtn>
            </span>
          </Row>
        ))}
      </Card>

      {/* 플레이북 */}
      <Card>
        <CardHead>
          <span><FileCode size={16} /> 플레이북 ({playbooks.length})</span>
          <IconBtn onClick={() => setEditor({ name: "", content: DEFAULT_PB })}><Plus size={13} /> 새 플레이북</IconBtn>
        </CardHead>
        {playbooks.length === 0 ? <Empty>플레이북이 없습니다. “새 플레이북”으로 만들어 보세요.</Empty> : playbooks.map((p) => (
          <Row key={p.pb_id} cols="1.5fr 2fr auto">
            <span style={{ fontWeight: 600, color: "#1e293b" }}>{p.name}</span>
            <Mono style={{ color: "#94a3b8", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {(p.content || "").split("\n").find((l) => l.trim()) || "(비어있음)"}
            </Mono>
            <span style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
              <IconBtn onClick={() => setEditor({ pb_id: p.pb_id, name: p.name, content: p.content || "" })}><Edit3 size={13} /> 편집</IconBtn>
              <IconBtn style={{ borderColor: "#fecaca", color: "#ef4444" }} onClick={() => delPb(p.pb_id)}><Trash2 size={13} /></IconBtn>
            </span>
          </Row>
        ))}
      </Card>

      {/* 실행 */}
      <Card>
        <CardHead><span><Play size={16} /> 실행</span></CardHead>
        <div style={{ display: "flex", flexWrap: "wrap", gap: ".7rem", alignItems: "center", padding: "1rem 1.5rem" }}>
          <span style={{ color: "#64748b", fontSize: ".86rem" }}>플레이북</span>
          <Select value={pbId} onChange={(e) => setPbId(e.target.value)}>
            <option value="">선택…</option>
            {playbooks.map((p) => <option key={p.pb_id} value={p.pb_id}>{p.name}</option>)}
          </Select>
          <ChevronRight size={16} color="#cbd5e1" />
          <span style={{ color: "#64748b", fontSize: ".86rem" }}>선택한 호스트 <strong style={{ color: "var(--accent)" }}>{sel.size}</strong>개</span>
          <Button primary onClick={run} disabled={busy === "run" || !pbId || sel.size === 0} style={{ marginLeft: "auto" }}>
            <Play size={15} /> {busy === "run" ? "실행 중…" : "플레이북 실행"}
          </Button>
        </div>
        {output && (
          <div style={{ padding: "0 1.5rem 1.25rem" }}>
            <div style={{ marginBottom: ".5rem" }}><Badge s={output.status}>{output.status}</Badge>
              {output.exit_code != null && <span style={{ color: "#94a3b8", fontSize: ".8rem", marginLeft: 8 }}>exit {output.exit_code}</span>}</div>
            <Pre>{output.output}</Pre>
          </div>
        )}
      </Card>

      {/* 실행 기록 */}
      {runs.length > 0 && (
        <Card>
          <CardHead><span><Terminal size={16} /> 실행 기록</span><IconBtn onClick={load}><RefreshCw size={13} /></IconBtn></CardHead>
          {runs.map((r) => (
            <Row key={r.run_id} cols="auto 1.5fr 1fr auto"
              style={{ cursor: "pointer" }}
              onClick={async () => {
                const d = await fetch(`${API}/runs/${r.run_id}`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json())
                setOutput(d); (document.querySelector('.console-content') || window).scrollTo({ top: 0, behavior: "smooth" })
              }}>
              <Badge s={r.status}>{r.status}</Badge>
              <span style={{ fontWeight: 600, color: "#1e293b" }}>{r.pb_name}</span>
              <span style={{ color: "#94a3b8", fontSize: ".8rem" }}>호스트 {String(r.host_ids || "").split(",").filter(Boolean).length}개</span>
              <span style={{ color: "#94a3b8", fontSize: ".78rem", textAlign: "right" }}>{new Date(r.created_at).toLocaleString()}</span>
            </Row>
          ))}
        </Card>
      )}
    </>
  )
}

/* ───────────────────────── Kubernetes (자리) ───────────────────────── */
function K8sPanel() {
  const { search } = useLocation()
  const target = nodeConsoleTarget(search)
  return (
    <Card>
      <CardHead><span><Boxes size={16} /> 운영·개발 클러스터와 서버</span>
        <a href={target.url} target="_blank" rel="noreferrer">새 창에서 보기</a>
      </CardHead>
      <iframe title="운영·개발 클러스터와 서버 관리" src={target.url}
        style={{ display: "block", width: "100%", minHeight: 1000, border: 0 }} />
    </Card>
  )
}

const Orchestration = () => {
  const [params, setParams] = useSearchParams()
  const tab = params.get('tab') === 'ansible' ? 'ansible' : 'k8s'
  const setTab = value => setParams(previous => { const next = new URLSearchParams(previous); next.set('tab', value); return next })
  return (
    <PageContainer>
      <Header>
        <div>
          <Title>오케스트레이션</Title>
          <Sub>서버 설정·배포는 Ansible, 컨테이너 배치·복구·확장은 K3s/Kubernetes.</Sub>
        </div>
      </Header>
      <Content>
        <TabBar>
          <TabBtn aria-pressed={tab === 'ansible'} active={tab === "ansible"} onClick={() => setTab("ansible")}><Network size={15} /> Ansible · 배포 자동화</TabBtn>
          <TabBtn aria-pressed={tab === 'k8s'} active={tab === "k8s"} onClick={() => setTab("k8s")}><Boxes size={15} /> K3s / Kubernetes · 실행 관리</TabBtn>
        </TabBar>
        <NodeSetupGuide section="orchestration" key={tab} defaultProfile={tab==='ansible'?'pm2':'k3s'}/>
        {tab === "ansible" ? <AnsiblePanel /> : <K8sPanel />}
      </Content>
    </PageContainer>
  )
}

export default Orchestration
